<template>
  <div class="col-md-9">
    <div class="card h-100 mb-0">
      <div class="card-body">
        <b-tabs
          pills
          justified
          ref="tabs"
          content-class="py-3 text-muted"
          v-model="internalTabIndex"
        >
          <slot></slot>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClienteRuralTabs",
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      internalTabIndex: this.value
    };
  },
  watch: {
    value(newVal) {
      this.internalTabIndex = newVal;
    },
    internalTabIndex(newVal) {
      this.$emit('input', newVal);
    }
  }
};
</script>
